import Controller from '@ember/controller';

import illustration from '@repo/visual-assets/illustrations/ill-qf-cp-general-rejected.svg';

import { MainLayout } from 'register-partners-js/react/components/layouts/main';

import styles from './styles.module.css';

export default class PaymentErrorController extends Controller {
  mainLayout = MainLayout;

  styles = styles;

  illustration = illustration;
}
